<template lang="pug">
.news-boxes(v-if="newsList")
	article.news-box(v-for="(article, index) in newsList.content")
		h3.news-box__title(:id="`a11y-news-box-${index}`") {{ article.title }}
		.news-box__published-lockup.sf-text-fineprint
			span.sr-only Published
			| {{ formatDate(article.date) }}
			template(v-if="article.tags.length")
				span.sr-only Topics:
				ul.news-box__tag-list
					li.news-box__tag-item(v-for="(tag, index) in article.tags")
						a.news-box__tag(@click.prevent="selectTag(tag)") {{ tag }}
		.news-box__text-content
			p {{ article.lead }}
		a#a11y-news-box-more-link.news-box__more-link(:href="article.url", aria-labelledby="a11y-news-box-more-link a11y-news-box") Read more
</template>
<script>
import { defineComponent } from '@vue/composition-api';
import { useNewsList, useNewsStore } from '../composables/news-composable';
import moment from 'moment';
export default defineComponent({
	setup() {
		const { newsList } = useNewsList();
		const { selectTag } = useNewsStore();
		const formatDate = (date) => {
			return moment(date).format('MMMM D, YYYY');
		};
		return {
			newsList,
			selectTag,
			formatDate
		};
	}
});
</script>
<style lang="scss" scoped>
.news-box__tag-list {
	display: inline;

	&::before {
		content: ' • ';
	}
}

.news-box__tag-list .news-box__tag-item {
	display: inline;

	&:not(:last-child)::after {
		content: ', ';
	}
}
</style>
